import React, { Fragment } from "react";

/**
 * Shadow me to add your own bio content
 */

export default ({ author, date }) => <Fragment>{author}</Fragment>;
